import React from 'react'
import _ from 'lodash'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSlidersH, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../assets/css/components/filter-popout-button.css'
import TytoSelect from '../components/TytoSelect'
import FilterPopoutButton from '../components/FilterPopoutButton'
library.add(faSlidersH, faTimes)

const ContentTypesPopoutFilter = props => {
  // FilterPopoutprops
  const { title, iconComponent, onCancel, onApply } = props
  // Selection Callbacks
  const { toggleContentType } = props
  // Dropdown data
  const { courseCollection, sectionCollection, studentCollection, selectedContentTypes, contentTypes } = props

  const handleToggleContentType = contentType => props.toggleContentType(contentType)

  return(
    <FilterPopoutButton title={title} iconComponent={iconComponent} onCancel={onCancel} onApply={onApply} backgroundWhite={true}>
      <p>Select the Assignment Type you'd like to show assignments for.</p>
      <p>You may select multiple options.</p>
      <TytoSelect
        selections={selectedContentTypes}
        placeholder='Select Content Type(s) or Start Typing'
        multiple={true}
        searchable={true}
        options={contentTypes}
        onSelect={val=>handleToggleContentType(val)}
      />
      {_.map(selectedContentTypes, (value,index)=>
        <span key={index}
          className='selected-filter'
          onClick={()=>handleToggleContentType(value)}>
          {(_.find(contentTypes, op=>op.value == value) || {}).label}
          <FontAwesomeIcon icon='times'/>
        </span>
      )}

    </FilterPopoutButton>
  );
}

export default ContentTypesPopoutFilter
